GP.GPMod('Profile',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;
    var _profile_text = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            _profile_text = js_lang.profile_text;
        },
        timout: 2000,
        current_duid: 0,
        interest_count: 0,
    };


    var gui = {
        init_global: function() {
            this.$header_thumbnails  = $('#mem-photo-t, #mem-photo-s');
            this.$profile_pic        = $(".main-photo");
        },
        init: function() {
            this.$html               = $('html');
            this.$body               = $('body');
            this.$btn_profile_pic    = $('#btn-main-photo');
            this.$btn_content_count  = $('#content_count');
            this.$profile_pic        = $(".main-photo");
            this.$header_thumbnails  = $('#mem-photo-t, #mem-photo-s, #profile-menu-link img');

            this.$profile_wrap       = $("#profile-wrap");
            this.$add_photo_lin      = $('#profile-media-photos .add-photo');
            this.$more_options_link  = $("#btn-more-options");
            this.$more_info_link     = $('.about-text .toggle');
            this.$modal_submit_btn   = $('#bs-notify-me-modal-submit');
            this.$details_link       = $("#btn-profile-details");

            this.$profile_options    = $('#profile-options');
            this.$status_area        = $('#status-area');

            this.$message_btn        = $('#option-message');
            this.$friend_btn         = $('#option-friend');
            this.$friend_requests    = $('#friend-requests');
            this.$wink_btn           = $('#option-wink');
            this.$sms_btn            = $('#option-sms');
            this.$tip_btn            = $('#option-tip');
            this.$favorite_btn       = $('#option-favorite');
            this.$notify_me_btn      = $('#option-notify');
            this.$no_photo_btn       = $('#no-photo-btn');

            this.$block_btn          = $('.block-btn');

            this.$close_profile_btn  = $('#close-profile-btn');

            // media dropdown menu actions
            this.$toggle_anon        = $('.profile-photo-wrap.edit .dropdown-menu .toggle-anon');
            this.$delete_gallery     = $('.profile-photo-wrap.edit .dropdown-menu .delete-gallery');

            this.$btn_scroll_top     = $('#btn-scroll-top');
            this.$btn_req_priv_media = $('.btn-req-priv-media');

            this.$premium_sect_wrap = $('#premium-sect-wrap');
            this.$btn_req_photos    = $('.btn-req-photos');

            this.$btn_private_upload = $('.btn-private-wrap .btn-private-upload');

            this.$btn_interest_search  = $('.js-interest-search');
        },
        get_success_div: function(message) {
            var $success = $("#clone-templates .success-block").clone();
                $success.children('.success-message').html(message);
                $success.children('a.close_status_message').on('click', function(e) {
                    e.preventDefault();
                    events.reset_status_area();
                });
            return $success;
        }
    };

    var apis = {
        add_friend: function(friend_duid) {
            self.api.post('network.add_friend', {
                data: {
                    fuid: friend_duid
                },
                success: handlers.friend_added
            });
        },
        send_wink: function(send_data) {
            self.api.post('msg.send_wink', {
                data:    send_data,
                success: handlers.winked
            });
        },
        add_favorite: function(send_data) {
            self.api.post('network.add_favorite', {
                data:    send_data,
                success: handlers.favorite_added
            });
        },
        modify_alerts: function(send_data) {
            self.api.post('network.mod_alerts', {
                data:    send_data,
                success: handlers.notify_me
            });
        },
        block_user: function(send_data) {
            self.api.post('user.block_user', {
                data:    send_data,
                success: handlers.user_blocked
            });
        },
        unblock_user: function(send_data) {
            self.api.post('network.blackbook_json', {
                data:    send_data,
                success: handlers.user_unblocked
            });
        },
        rate_pic: function(score, picnum, $ele) {
            var actual_score = score * 2;

            self.api.post('user.rate_user_pic', {
                data:    {
                    duid:    $ele.data('duid'),
                    pic_num: picnum,
                    score:   actual_score
                },
                success: function(json) {
                    // handlers.pic_rated(json, $ele);
                }
            });
        },
        rate_gallery_media: function(score, media_id, $ele) {
            var actual_score = score * 2;
            self.api.post('media.rating', {
                data:    {
                    duid:   $ele.data('duid'),
                    mid:    media_id,
                    value:  actual_score
                },
                success: function(json) {
                    handlers.pic_rated(json, $ele);
                }
            });
        },
        set_primary_pic: function(content_id, md5, content_media_id, $pic_wrapper, legacy_id) {
            pic_data = {
                    action: 'primary',
                    content_id: content_id,
                    content_media_id: content_media_id,
                    file_md5: md5,
            };
            // Check for legacy_id
            if (legacy_id !== null) {
                pic_data.legacy_id = legacy_id;
            }
            self.api.post('user.manage_pics', {
                data: pic_data,
                success: function(json) {
                    handlers.primary_pic_set(json, $pic_wrapper);
                }
            });
        },
        delete_profile_pic: function(content_id, $pic_wrapper) {
            self.api.post('user.manage_pics', {
                data: {
                    action: 'remove',
                    content_id: content_id
                },
                success: function(json) {
                    handlers.media_removed(json, $pic_wrapper);
                }
            });
        },
        toggle_anon: function(media_id, action, media_type, $pic_wrapper) {
            self.api.post('media.manage', {
                data: {
                    mid:       media_id,
                    action:    action,
                    mediatype: media_type
                },
                success: function(json) {
                    handlers.anonymous_toggled(json, $pic_wrapper);
                }
            });
        },
        delete_gallery: function(media_id, media_type, $pic_wrapper) {
            self.api.post('media.manage', {
                data:    {
                    mid:       media_id,
                    action:    'remove',
                    mediatype: media_type
                },
                success: function(json) {
                    handlers.media_removed(json, $pic_wrapper);
                }
            });
        },
        request_private_media: function() {
            self.api.post('content.request_private_media.php', {
                data:    {
                    owner_duid: user_duid,
                },
                success: function(json) {
                    if (_util.check_obj(json.status)) {
                        if (_util.check_obj(json.auto_approved)) {
                            gui.$btn_req_priv_media.text('Loading');
                            GP.vent.trigger('Content:get_private_content');
                        } else {
                            handlers.update_private_request_btn();
                        }
                    }
                }
            });
        },
        request_photos: function() {
            $.post('/members/user/profile', {
                to_duid: user_duid,
                action: 'do_pic_request'
            }).done(function(json) {
                if (json.status) {
                    gui.$btn_req_photos.addClass('disabled').off('click');
                }
            });
        }
    };

    var handlers = {
        user_blocked: function(json) {
            if (_util.check_obj(json.status)) {
                gui.$block_btn.text(_profile_text.user_blocked);
                gui.$block_btn.off('click');

                window.location.reload(true);
            }
        },
        user_unblocked: function(json) {
            if (_util.check_obj(json.success)) {
                window.location.replace('/members/user/profile/?duid='+user_duid);
            }
        },
        friend_added: function(json) {
            if (_util.check_obj(json.status)) {
                gui.$profile_options.hide();

                var $success_div = gui.get_success_div(_profile_text.friend_added);
                gui.$status_area.html($success_div).show();

                if (json.message == 'Friend added.') {
                    gui.$friend_btn.find('#friend-text').text(_profile_text.friend_request_approved);
                    gui.$friend_btn.addClass('cancel-event');
                    gui.$friend_requests.trigger('click');
                } else {
                    gui.$friend_btn.find('#friend-text').text(_profile_text.friends);
                }
                gui.$friend_btn.off('click');

                _util.timers.set(events.reset_status_area, 3000);
            }
        },
        winked: function(json) {
            if (_util.check_obj(json.status)) {
                gui.$profile_options.hide();

                var $success_div = gui.get_success_div(js_lang.search_winked);
                gui.$status_area.html($success_div).show();

                gui.$wink_btn.find('#wink-text').text(js_lang.search_winked);
                gui.$wink_btn.off('click');

                _util.timers.set(events.reset_status_area, 3000);
            }
        },
        favorite_added: function(json) {
            var $success_div;
            if (_util.check_obj(json.status)) {
                gui.$profile_options.hide();

                $success_div = gui.get_success_div(js_lang.search_favorited);
                gui.$status_area.html($success_div).show();

                gui.$favorite_btn.addClass('cancel-event').find('#fav-text').text(js_lang.search_favorited);
                gui.$favorite_btn.off('click');

                _util.timers.set(events.reset_status_area, 3000);
            } else if (_util.check_obj(json.message)) {
                gui.$profile_options.hide();

                $success_div = gui.get_success_div(json.message);
                gui.$status_area.html($success_div).show();

                _util.timers.set(events.reset_status_area, 3000);
            }
        },
        notify_me: function(json) {
            var checked_opts = $('.notify-me .alert_opt:checked');
            if (json.status) {
                $('#alert-types').empty();
                if (checked_opts.length) {
                    $.each(checked_opts, function(i, obj) {
                        $('#alert-types').prepend('<input type="hidden" name="types[]" value="'+$(obj).val()+'">');
                    });
                }
                $('.form-checkboxes').hide();
                $('#alert_result').text(alert_msg_saved).show();
                setTimeout(function() {
                    vent.trigger('Modal:close');
                }, 1200);
            } else {
                $('.alert_form, .alert_info').hide();
                $('#alert_result').text(alert_msg_error).show();
                setTimeout(function() {
                    vent.trigger('Modal:close');
                }, 1500);
            }
        },
        pic_rated: function(json, $ele) {
            // $ele.html("<div style='height:20px;font-size:12px;color:#666'>"+_profile_text.rating_submitted+"</div>");
        },
        primary_pic_set: function(json, $pic_wrapper) {
            if (typeof json != 'undefined') {
                if (_util.check_nested(json, 'profile_pic.urls')) {
                    var pic_urls = json.profile_pic.urls;

                    var header_thumbnail = pic_urls.S;
                    // if no pic placeholder returned, use special one for header_thumbnail
                    header_thumbnail = header_thumbnail.replace('nopic-','nopic-ALL-');

                    // the M size may not exists (old gallery pics etc), so check and use the L pic as a backup
                    var profile_pic  = (pic_urls.M ? pic_urls.M : pic_urls.L);

                    // get rid of private content upload popover once they have a pic
                    if (!json.profile_pic.no_pic && gui.$btn_private_upload) {
                        gui.$btn_private_upload.popover('destroy');
                    }

                    if (gui.$btn_profile_pic) {
                        if (json.profile_pic.hasOwnProperty('no_pic') && json.profile_pic.no_pic) {
                            // user has no pics
                            gui.$btn_profile_pic.attr({
                                'href'       : '/members/user/upload_pic/',
                                'data-event' : 'Modal:open'
                            })
                            .addClass('no-photo');
                        } else {
                            gui.$btn_profile_pic.attr({
                                'href'       : '/members/content/viewer/?type=profile&show_modal=1&type=IMAGE&duid=' + GP.sdata.my_user.duid + '&content_id=' + json.profile_pic.content_id,
                                // 'href'       : '/members/user/profile/?type=profile&show_modal=1&type=IMAGE&duid=' + GP.sdata.my_user.duid + '&content_id=' + json.profile_pic.content_id,
                                'data-event' : 'Modal:open'
                            })
                            .removeClass('no-photo');
                        }
                    }
                    if (gui.$profile_pic) {
                        if (json.profile_pic.hasOwnProperty('no_pic') && json.profile_pic.no_pic) {
                            // no pic so show the addphoto stand in pic
                            profile_pic = profile_pic.replace('thumbs/nopic-M','fl_addphoto_profile');
                            gui.$profile_pic.attr({
                                'src' : profile_pic,
                                'id'  : 'add-photo'
                            });
                        } else {
                            gui.$profile_pic.attr({
                                'src' : profile_pic,
                                'id'  : 'main-photo'
                            });
                        }
                    }

                    if (gui.$header_thumbnails) {
                        gui.$header_thumbnails.attr('src', header_thumbnail);
                    }

                    // update collection with newest myuser.pic since it was just updated
                    GP.sdata.my_user.pic = header_thumbnail;
                    if (typeof $pic_wrapper != 'undefined') {
                        var $alert = $("#clone-templates .alert-templates .alert-success").clone();
                        $alert.addClass('alert-media-success');
                        $alert.html(_profile_text.primary_pic_set);
                        _util.gui.show_alert($pic_wrapper, $alert);
                    }

                    // Clear Page Cache
                    vent.trigger("Page:clear_local_cache");
                }
            }
        },
        media_removed: function(json, $pic_wrapper) {
            if (typeof json != 'undefined') {
                if (_util.check_obj(json.pics) || _util.check_obj(json.success)) {
                    $pic_wrapper.fadeOut("slow", function() {
                        $(this).remove();
                    });
                }
            }
        },
        anonymous_toggled: function(json, $pic_wrapper) {
            if (typeof json != 'undefined') {
                if (_util.check_obj(json.success)) {
                    $pic_wrapper.toggleClass('anonymous').children('h4.anonymous').toggleClass('hidden');
                    $pic_wrapper.find('.toggle-anon').toggleClass('hidden');
                }
            }
        },
        update_private_request_btn: function() {
            gui.$btn_req_priv_media.text(gui.$btn_req_priv_media.data('pending'));
        }
    };

    var events = {
        init: function() {
            vent.on('init_js:user:profile', events.setup_binds);
            vent.on('init_js:user:profile_blocked',events.profile_blocked);
            vent.on('Profile:update_duid', events.update_current_duid);
            vent.on('Profile:stream_started', events.stream_started);

            vent.on('picrating:setup', events.setup_pic_rating);

            // just send to the api so the handler can be used.  events.set_primary_pic will look for data-picnum
            vent.on('profile:set_primary_pic', apis.set_primary_pic);

            // update primary pic when content is updated
            vent.on('profile:primary_pic_set', handlers.primary_pic_set);

            // setup events specific to profile edit
            vent.on('init_js:user:edit_user_profile', events.setup_profile_edit);

            vent.on(self.moduleName+":remove_scrolltop_button",events.remove_scrolltop_button);
            vent.on('profile:handle_primary_pic_set', events.handle_primary_pic_set);
            vent.on('profile:handle_no_pics', events.handle_no_pics);

            vent.on('profile:send_message', events.send_message);
            vent.on('profile:add_friend', apis.add_friend);

            vent.on(self.moduleName+":setup_choose_interests_modal",events.setup_choose_interests_modal);
        },
        update_current_duid: function(json) {
            if (json && json.duid) {
                data.current_duid = parseInt(json.duid, 10) || 0;
                return;
            }

             data.current_duid = 0;
        },
        stream_started: function(json) {
            if (json && json.room_id) {
                var room_id = parseInt(json.room_id, 10) || null;
                if (room_id && data.current_duid && data.current_duid === room_id) {
                    // add watch now button
                    $('.js-join-room-btn').removeClass('hide');
                }
            }
        },
        profile_blocked: function () {
            $('#unblock').on('click', events.handle_block);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();

            gui.$more_info_link.on('click', events.toggle_more_info);

            gui.$message_btn.on('click', events.send_message);
            if (GP.sdata.my_user.membership == 'BRONZE') {
                gui.$friend_btn.on('click', events.add_friend);
            } else {
                gui.$friend_btn.one('click', events.add_friend);
            }
            gui.$wink_btn.one('click', events.send_wink);
            gui.$sms_btn.on('click', events.open_sms_modal);
            gui.$favorite_btn.one('click', events.add_favorite);
            gui.$notify_me_btn.on('click', events.notify_me);
            gui.$tip_btn.on('click', events.open_tip_modal);
            gui.$modal_submit_btn.on('click', function(e) {
                $("#notify-modal form.notify-me").submit();
            });

            gui.$more_options_link.on('click', events.toggle_more_options);
            gui.$details_link.on('click', events.toggle_details);
            gui.$block_btn.on('click', events.handle_block);

            gui.$no_photo_btn.on('click', events.send_message);

            // pic management
            // $('body')
            // .on("mouseenter", '.profile-photo-wrap.edit', events.show_edit_pic_button)
            // .on("mouseleave", '.profile-photo-wrap.edit', events.hide_edit_pic_button);

            // $('#profile-media-photos').on('click', '.dropdown-menu .primary', events.set_primary_pic);
            // $('#profile-media-photos').on('click', '.dropdown-menu .delete', events.delete_profile_pic);
            gui.$toggle_anon.on('click', events.toggle_anon);
            gui.$delete_gallery.on('click', events.delete_gallery);

            events.setup_pic_rating($('#profile-media-photos'));

            gui.$btn_profile_pic.on('click', events.profile_pic_click);
            gui.$btn_content_count.on('click', events.profile_pic_click);

            events.show_scrolltop_button();
            gui.$btn_scroll_top.on('click', events.handle_scrolltop_button);

            gui.$close_profile_btn.on('click', function(e) {
                window.top.close();
                // window.history.back();
            });

            // var ad_block_status = (typeof window._ads_js_loaded == 'undefined') ? 'on' : 'off';
            // $.post('/members/util/log', {status: ad_block_status});

            gui.$btn_req_priv_media.on('click', events.request_private_media);
            gui.$btn_req_photos.on('click', events.request_photos);

            gui.$btn_private_upload.on('click', events.upload_private);

            // setup private content upload popover if no profile pics
            if (!GP.sdata.my_user.has_pic) {
                events.handle_no_pics();
            }

            gui.$btn_interest_search.on('click', events.interest_search);
        },
        setup_profile_edit: function() {
            var loc_obj = {};

            $('#city_name').typeahead({
                minLength: 3,
                items: 'all',
                source: function(query, process) {
                    var country_code = $('#country_code option:selected').val();
                    return $.get('/members/geo/suggest_city/?jq=1&country_code='+country_code, { location_name: query }, function(data) {
                        loc_obj = {};
                        var names = [];
                        $.map(data, function(val, i) {
                            if (Boolean(val.desc)) {
                                loc_obj[val.desc] = val.location_id;
                                names.push(val.desc);
                            }
                        });
                        return process(names);
                    });
                },
                updater: function (name) {
                    $('#location_id').val(loc_obj[name]);
                    return name;
                }
            });

            // if the user doesn't click the typeahead suggestion the location_id wont get set
            // try to set it on blur if the input has a valid zip code (doesn't work for city name)
            $('#city_name').blur(function() {
                var val = $(this).val();
                if (val.length && !$.isEmptyObject(loc_obj)) {
                    $.each(loc_obj, function(location_desc, location_id) {
                        if (location_id == val) {
                            $('#location_id').val(location_id);
                        }
                    });
                } else {
                    $('#location_id').val('');
                }
            });
        },
        setup_pic_rating: function($container) {
            if (typeof $container != 'undefined') {
                $container.find('.pic-rating').each(function() {
                    var self    = $(this);
                    var start   = self.attr('data-score');
                    var gallery = self.hasClass('gallery') ? true : false;

                    if (start > 0 && !gallery) {
                        start = start / 2;
                    }

                    self.raty({
                        click: function(score, evt) {
                            var actual_score = score * 2;
                            self.attr('data-score', actual_score);

                            if (gallery) {
                                apis.rate_gallery_media(score, self.attr('data-media-id'), self);
                            } else {
                                apis.rate_pic(score, self.attr('data-picnum'), self);
                            }
                        },
                        start: start
                    });
                });
            }
        },
        show_edit_pic_button: function(e) {
            if (gui.$html.hasClass('desktop') || gui.$html.hasClass('desktop-wide')) {
                $(e.currentTarget).addClass('dropdown-shown');
            }
        },
        hide_edit_pic_button: function(e) {
            if (gui.$html.hasClass('desktop') || gui.$html.hasClass('desktop-wide')) {
                $(e.currentTarget).removeClass('dropdown-shown');
            }
        },
        set_primary_pic: function(e) {
            e.preventDefault();
            var $pic_wrapper = $(this).parents('.profile-photo-wrap');

            if (confirm(_profile_text.confirm_pri)) {
                apis.set_primary_pic($(this).data('picnum'), $pic_wrapper);
            }
        },
        delete_profile_pic: function(e) {
            e.preventDefault();
            var $pic_wrapper = $(this).parents('.profile-photo-wrap');

            if (confirm(_profile_text.confirm_del)) {
                apis.delete_profile_pic($(this).data('picnum'), $pic_wrapper);
            }
        },
        // toggle anonymous flag (show/hide from profile)
        toggle_anon: function(e) {
            e.preventDefault();
            var $ele = $(this);
            var $pic_wrapper = $ele.parents('.profile-photo-wrap');

            apis.toggle_anon($ele.data('id'), $ele.data('action'), $ele.data('type'), $pic_wrapper);
        },
        delete_gallery: function(e) {
            e.preventDefault();
            var $ele = $(this);
            var $pic_wrapper = $ele.parents('.profile-photo-wrap');

            if (confirm(_profile_text.confirm_del)) {
                apis.delete_gallery($ele.data('id'), $ele.data('type'), $pic_wrapper);
            }
        },
        open_sms_modal: function(e) {
            e.preventDefault();

            if (GP.sdata.my_user.membership == 'FREE') {
                GP.vent.trigger('Page:billing_redirect');
            } else {
                vent.trigger('Modal:open', {
                    url: '/members/user/plivo/',
                    duid: user_duid,
                    modal: true
                });
            }
        },
        open_tip_modal: function(e) {
            e.preventDefault();

            if (GP.sdata.my_user.membership == 'FREE' && !GP.sdata.my_user.can_oneclick) {
                GP.vent.trigger('Page:billing_redirect');
            } else {
                vent.trigger('Modal:open', {
                    url: '/members/user/tip/',
                    duid: user_duid,
                    modal: true
                });
            }
        },
        handle_block: function(e) {
            e.preventDefault();

            if ($(this).data('action') == 'block') {
                if (confirm(js_lang.block_user.replace('%username%', _profile_text.profile_username))) {
                    var block_data = {
                        block_duid: user_duid
                    };
                    apis.block_user(block_data);
                }
            } else {
                var unblock_data = {
                    ajax_request: true,
                    action: 'mass_unblock',
                    duids: [user_duid]
                };
                apis.unblock_user(unblock_data);
            }
        },
        toggle_more_options: function(e) {
            e.preventDefault();

            $('.more-options-wrap').slideDown('fast');
            $(this).hide();
            e.stopImmediatePropagation();
            return false;
        },
        toggle_more_info: function(e) {
            e.preventDefault();
            var self = $(this);
            if (self.hasClass('more')) {
                self.closest('.collapsed').addClass('hide');
                self.closest('.about-text').find('.expanded').removeClass('hide');
            } else {
                self.closest('.expanded').addClass('hide');
                self.closest('.about-text').find('.collapsed').removeClass('hide');
            }
        },
        toggle_details: function(e) {
            // e.preventDefault();

            $('#profile-extended-wrap').slideDown('fast');
            $(this).hide();

            // returning false here will automatically call
            // e.stopPropagation() and e.preventDefault()

            return false;
        },
        reset_status_area: function() {
            gui.$profile_options.show();
            gui.$status_area.hide();
        },
        send_message: function(e) {
            // console.log('send_message _thread_json: ', _thread_json);

            // this function might not be called via click event
            if (e) {
                e.preventDefault();
            }

            vent.trigger('MessagePane:send_message', user_duid, _thread_json);

        },
        handle_bronze: function() {

            // TODO: breakup into smaller methods/handlers

            // first check unlocked status
            self.api.json('msg.get_unlocked_status', {
                data: {
                    duid: user_duid,
                }
            }).done(function(json) {
                // console.log('handle_bronze get_unlocked_status json: ', json);

                // open thread normally if thread is already unlocked
                if (json && json.unlocked) {
                    vent.trigger('MessagePane.Inbox:load_thread_external', _thread_json);
                    return;
                }

                // open modal to spend/purchase credits if thread isn't unlocked
                vent.trigger('Modal:open', {
                    url: '/members/billing/unlock_thread_modal/',
                    duid: user_duid,
                    thread_json: _thread_json,
                    price: json.price,
                });

            }).fail(function() {
                // err msg?
            });
        },
        add_friend: function(e) {
            e.preventDefault();

            var $clicked = $(e.currentTarget);
            if ($clicked.hasClass('cancel-event')) {
                return true;
            }

            // handle purchase friend request if BRONZE user
            if (GP.sdata.my_user.membership == 'BRONZE') {
                GP.vent.trigger('Unlock:show_friend_request_modal', user_duid);
                return;
            }

            if (GP.sdata.my_user.membership == 'FREE') {
                GP.vent.trigger('Page:billing_redirect');
            } else {
                apis.add_friend(user_duid);
            }
        },
        send_wink: function(e) {
            e.preventDefault();

            var form_data = {
                fduid: user_duid
            };

            if (GP.sdata.my_user.membership == 'FREE') {
                GP.vent.trigger('Page:billing_redirect');
            } else {
                apis.send_wink(form_data);
            }
        },
        add_favorite: function(e) {
            e.preventDefault();

            var $clicked = $(e.currentTarget);
            if ($clicked.hasClass('cancel-event')) {
                return true;
            }

            var form_data = {
                fduid: user_duid,
                process: 1
            };
            apis.add_favorite(form_data);
        },
        notify_me: function(e) {
            e.preventDefault();

            if (GP.sdata.my_user.membership == 'FREE') {
                GP.vent.trigger('Page:billing_redirect');
            } else {
                var obj = {
                    modal_options: {
                        backdrop:      true,
                        keyboard:      true
                    },
                    modal_div: $("#notify-modal"),
                    shown: events.notify_me_shown
                };

                vent.trigger('Modal:open:static', obj);
            }
        },
        notify_me_shown: function(e) {
            var alert_form = $('.notify-me');
            var alert_duid = gui.$profile_wrap.data('duid');
            alert_form.find('input[name="alert_duid"]').val(alert_duid);
            var types = $('#alert-types input[name="types[]"]');
            if (types.length) {
                $.each(types, function(i, type) {
                    alert_form.find('input[value="'+$(type).val()+'"]').attr('checked', 'checked');
                });
            }
            _main_pic_url = gui.$profile_wrap.find('#main-photo').css('background-image').replace('url(','').replace(')','').replace(/\"/gi, "");
            $('#alert_pic').css('background-image', 'url("' + _main_pic_url + '")');
            $('#alert_username').text(gui.$profile_wrap.data('username'));
            $('#alert_age').text(gui.$profile_wrap.data('age'));
            $('#alert_location').text(gui.$profile_wrap.data('location'));
            $('.alert_info').hide();
            $('.form-checkboxes').show();
            alert_form.show();

            $("#notify-modal form.notify-me").on('submit', events.notify_me_submit_handler);
        },
        notify_me_submit_handler: function(e) {
            e.preventDefault();
            apis.modify_alerts($(this).serialize());
        },
        profile_pic_click: function(e) {
            e.preventDefault();

            let img_url = $('#main-photo').css('background-image');

            if (img_url.match(/cacheb/i)) {
                // pop unlock modal if blurred content
                GP.vent.trigger('Unlock:show_unlock_modal', gui.$profile_wrap.data('duid'));
            } else if (MoshPit.get_size() == 'mobile' && !gui.$btn_profile_pic.hasClass('no-photo')) {
                var media_anchor = gui.$btn_profile_pic.data('anchor');
                $('html, body').animate({
                    'scrollTop': ($('#' + media_anchor).offset().top) - 50
                }, 300);
            }
        },
        show_scrolltop_button: function() {
            var btn_show_timeout = 0,
                last_scrolltop = 0,
                window_height = $(window).height() - 40; // 40 pixels to account for header height

            $(window).on('scroll.scrolltop_btn', function(e){
                var scrolltop = $(window).scrollTop();

                if (btn_show_timeout) {
                    clearTimeout(btn_show_timeout);
                    btn_show_timeout = 0;
                }

                if (scrolltop < last_scrolltop) {
                    btn_show_timeout = setTimeout(function(){
                        if (window_height < scrolltop) {
                            $('body').addClass('show-scrolltop-btn');
                        } else {
                            $('body').removeClass('show-scrolltop-btn');
                        }
                    }, 100);
                }
                last_scrolltop = (scrolltop < 0) ? 0 : scrolltop;
            });
        },
        remove_scrolltop_button: function() {
            $(window).off('scroll.scrolltop_btn');
            $('body').removeClass('show-scrolltop-btn');
        },
        handle_scrolltop_button: function() {
            $('html, body').animate({ scrollTop: 0 }, 400);
            $('body').removeClass('show-scrolltop-btn');
        },
        request_private_media: function() {
            apis.request_private_media();
            $(this).attr('disabled', true);
            $(this).addClass('disable-link');
        },
        handle_primary_pic_set: function(json) {
            var $pic_wrapper = $(this).parents('.profile-photo-wrap');
            handlers.primary_pic_set(json, $pic_wrapper);
        },
        request_photos: function() {
            vent.trigger('Modal:open:confirm', {template: 'REQUEST_PHOTOS'}, function() {
                apis.request_photos();
            });
        },
        upload_private: function(e) {
            var $clicked = $(e.currentTarget);

            if (GP.sdata.my_user.has_pic) {
                vent.trigger('Modal:open', {
                    url: '/members/user/upload_pic',
                    private: true
                });
            }
        },
        handle_no_pics: function() {
            gui.$btn_private_upload.popover();
        },
        setup_choose_interests_modal: function() {
            data.interest_count = 0;
            $('.btn-reset-interest').on('click', function(e) {
                $('.update-interest-form .checkbox-interest').prop("checked", false);
                data.interest_count = 0;
                $('.text-count-current').text(data.interest_count);
            });

            // handle search filter
            $('.input-search-interests').on('keyup', function(e) {
                let filter_text = $(this).val().toLowerCase();

                $('.checkbox-pill-wrap').each(function() {
                    let $checkbox_val = String($(this).data('value'));
                    if ($checkbox_val.indexOf(filter_text) > -1) {
                        $(this).css('display', 'inline-block');
                    } else {
                        $(this).css('display', 'none');
                    }
                });
            });
            events.update_interests_total();
            events.handle_interests_change();
        },
        update_interests_total_text: function() {
            $('.text-count-current').text(data.interest_count);
        },
        update_interests_total: function() {
            $('.update-interest-form input[name="interests[]"]').each(function() {
                if ($(this).is(':checked')) {
                    data.interest_count = data.interest_count + 1;
                    events.update_interests_total_text();
                }
            });
        },
        handle_interests_change: function() {
            $('.update-interest-form input[name="interests[]"]').on('change.'+data.event_namespace, function(e) {

                if (data.interest_count === _user_interests_max) {
                    if ($(this).is(':checked')) {
                        $(this).prop("checked", false);
                    } else {
                        data.interest_count = data.interest_count - 1;
                        events.update_interests_total_text();
                    }

                } else if (data.interest_count < _user_interests_max) {
                    data.interest_count = $(this).is(':checked') ? data.interest_count + 1 : data.interest_count - 1;
                    events.update_interests_total_text();
                }
            });
        },
        interest_search: function() {
            window.location.href = '/members/search/quicksearch/?process=Search&update_selected=1&interests%5B%5D=' + $(this).data('value');
        }
    };

    this.addInitializer(function(){
        data.init();
        gui.init_global();
        events.init();

    });
});
